<template>
  <div class="pad" ref="pad" :class="{ has: hasInk }">
    <div class="base"></div>
    <canvas
      ref="canvas"
      @pointerdown="onDown"
      @pointermove="onMove"
      @pointercancel="onUp"
    ></canvas>

    <div class="ph" aria-hidden="true">
      <div class="ph-demo">
        <div class="sig-wrap">
          <svg class="sig" viewBox="0 0 269 218" fill="none" aria-hidden="true">
                              <path fill="currentColor" d="M161.17 0.0259127C163.309 -0.0840531 164.308 0.137675 166.248 1.04507C168.897 2.28273 171.024 5.60613 171.768 8.38007C177.493 29.7584 162.345 73.8522 153.016 92.0299C164.394 91.2584 175.747 89.6581 187.139 88.8312C203.771 87.6248 253.393 85.2854 265.436 95.2524C266.424 96.0703 268.03 97.5584 268.156 98.8626L267.61 99.0994C263.028 96.4315 253.508 95.9671 247.952 95.5147C234.418 94.332 220.83 93.8821 207.246 94.1674C187.311 94.7112 169.903 96.8336 150.198 98.8812C144.347 110.18 139.153 120.731 132.352 131.668C125.818 142.359 118.563 152.573 111.744 163.08C110.602 164.841 107.612 171.843 106.272 172.397L105.926 171.767C105.85 169.155 106.348 165.238 107.658 162.969C119.776 141.982 134.531 122.415 144.137 99.9644C136.711 100.48 125.525 102.479 117.861 103.64C116.996 103.812 115.921 103.77 115.652 104.715C108.574 129.433 102.705 154.613 95.9351 179.413C93.767 187.354 87.9315 213.311 82.3313 217.653C81.2758 217.936 80.3353 218.037 79.3205 217.52C77.6293 216.657 76.9561 214.418 76.6561 212.69C75.5463 206.295 76.6072 198.809 77.2106 192.381C78.3696 180.029 84.5778 135.277 81.7286 127.431C75.1179 109.222 11.667 133.291 1.89815 128.001C1.02415 127.528 0.270547 126.67 0.0542028 125.682C-0.143453 124.777 0.223102 123.897 0.77043 123.189C2.00237 121.596 4.13921 120.54 5.98532 119.818C15.6543 116.034 26.865 114.196 37.0141 111.971C61.5034 106.533 86.1784 101.966 110.992 98.2793C113.218 89.5133 117.515 76.0295 120.676 67.7189C126.993 51.1108 141.638 3.74966 161.17 0.0259127Z" />
                              <path class="sig-cut" d="M162.259 5.02039C167.718 5.86454 167.93 15.484 167.729 19.5988C166.593 43.0409 157.738 72.1545 147.214 93.0937C140.226 93.5249 129.61 95.3997 122.531 96.4627L117.754 97.1128C118.46 93.6953 120.624 86.9147 121.708 83.6079C127.441 66.1222 143.849 10.399 162.259 5.02039Z" />
                              <path class="sig-cut" d="M106.503 105.366C107.012 105.272 107.562 105.308 108.091 105.309L108.534 105.884C108.594 108.068 101.558 132.689 100.461 136.826L89.8182 178.003C87.7672 185.704 85.7878 194.025 82.8456 201.367C82.9441 193.88 84.4833 182.635 85.3199 175.04C86.932 161.779 88.6905 148.835 89.084 135.465C89.7413 113.132 73.3329 114.514 56.6231 114.551C62.1934 112.87 71.2658 111.416 77.1649 110.362C86.9252 108.586 96.7049 106.921 106.503 105.366Z" />
                            </svg>
        </div>
        <span class="ph-hand"><svg viewBox="0 -960 960 960" fill="currentColor"><path d="M398-120q-27 0-51.5-11.5T305-164L46-483l26-25q19-19 45-22t47 12l116 81v-403q0-17 11.5-28.5T320-880q17 0 28.5 11.5T360-840v320h80v-160q0-17 11.5-28.5T480-720q17 0 28.5 11.5T520-680v160h80v-120q0-17 11.5-28.5T640-680q17 0 28.5 11.5T680-640v120h80v-40q0-17 11.5-28.5T800-600q17 0 28.5 11.5T840-560v280q0 66-47 113t-113 47H398Z" /></svg></span>
      </div>
      <div class="ph-title">اینجا امضا کنید</div>
      <div class="ph-sub">با انگشت خود، امضایتان را در این کادر بکشید</div>
    </div>

    <button v-if="hasInk" type="button" class="padclear" @click="clear">
      <base-icon name="trash" />پاک کردن
    </button>
  </div>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";

/**
 * Finger/stylus signature canvas.
 *
 * Sizing is device-pixel-ratio aware: the backing store is scaled up by `dpr` and the
 * context transformed back down, so strokes are crisp on a phone instead of soft.
 *
 * The stroke colour is read from `--foreground` rather than hardcoded, so a signature
 * drawn in dark mode is not invisible against the pad.
 */
export default {
  name: "SignaturePad",
  components: { BaseIcon },

  data() {
    return { hasInk: false };
  },

  created() {
    // Canvas context and in-progress stroke state: not rendered from, so not reactive.
    this.ctx = null;
    this.drawing = false;
    this.last = null;
  },

  mounted() {
    this.resize();
    window.addEventListener("resize", this.onResize);
    window.addEventListener("pointerup", this.onUp);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("pointerup", this.onUp);
    clearTimeout(this.resizeTimer);
  },

  methods: {
    /**
     * Size the backing store to the element. Called on mount, and again on resize —
     * where the existing drawing is carried across, because a phone rotating must not
     * silently erase a signature the user already made.
     */
    resize(preserve) {
      const pad = this.$refs.pad;
      const canvas = this.$refs.canvas;
      if (!pad || !canvas) return;

      const width = pad.clientWidth;
      const height = pad.clientHeight;
      if (!width || !height) return;

      const previous = preserve && this.hasInk ? canvas.toDataURL("image/png") : null;

      const dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);

      const ctx = canvas.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineWidth = 2.8;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = this.penColor();
      this.ctx = ctx;

      if (previous) {
        const image = new Image();
        image.onload = () => ctx.drawImage(image, 0, 0, width, height);
        image.src = previous;
      }
    },

    onResize() {
      // Resize fires in bursts while a rotation animates; only the final size matters.
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.resize(true), 120);
    },

    penColor() {
      return (
        getComputedStyle(document.documentElement).getPropertyValue("--foreground").trim() || "#111"
      );
    },

    /** Re-read the pen colour after a theme change so new strokes stay legible. */
    retheme() {
      if (this.ctx) this.ctx.strokeStyle = this.penColor();
    },

    pointFrom(event) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    },

    onDown(event) {
      if (!this.ctx) this.resize();
      if (!this.ctx) return;
      this.drawing = true;
      this.last = this.pointFrom(event);
      event.preventDefault();
    },

    onMove(event) {
      if (!this.drawing || !this.ctx) return;
      const point = this.pointFrom(event);
      this.ctx.beginPath();
      this.ctx.moveTo(this.last.x, this.last.y);
      this.ctx.lineTo(point.x, point.y);
      this.ctx.stroke();
      this.last = point;

      if (!this.hasInk) {
        this.hasInk = true;
        this.$emit("change", true);
      }
      event.preventDefault();
    },

    onUp() {
      this.drawing = false;
    },

    clear() {
      const canvas = this.$refs.canvas;
      if (this.ctx && canvas) this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.hasInk = false;
      this.$emit("change", false);
      this.$emit("clear");
    },

    /** @returns {string|null} a PNG data-URL, or null if nothing has been drawn. */
    toDataUrl() {
      return this.hasInk ? this.$refs.canvas.toDataURL("image/png") : null;
    },
  },
};
</script>

<style scoped>
.pad {
  position: relative;
  flex: 1;
  min-height: 240px;
  margin-top: 8px;
  border-radius: 18px;
  border: 2px dashed var(--border);
  background: var(--muted);
  overflow: hidden;
  /* Without this the browser claims the gesture for scrolling and the stroke breaks up. */
  touch-action: none;
}

.pad canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.base {
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 26%;
  border-bottom: 2px solid var(--border);
  z-index: 0;
}

.ph {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--muted-foreground);
  pointer-events: none;
  transition: opacity 0.25s;
  padding: 20px;
  text-align: center;
}

.pad.has .ph {
  opacity: 0;
}

.ph-demo {
  position: relative;
  width: min(64%, 210px);
  color: var(--primary);
  margin: 0 auto;
}

.sig-wrap {
  width: 100%;
}

.ph-demo >>> .sig {
  width: 100%;
  height: auto;
  display: block;
  overflow: visible;
}

.ph-demo >>> .sig-cut {
  fill: var(--muted);
}

.ph-hand {
  position: absolute;
  top: 38%;
  left: 8%;
  width: 40px;
  color: var(--foreground);
  transform: translate(-50%, 0);
  filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.5));
}

.ph-hand >>> svg {
  width: 100%;
  height: auto;
  display: block;
}

.ph-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--foreground);
}

.ph-sub {
  font-size: 13.5px;
  color: var(--muted-foreground);
  max-width: 230px;
  line-height: 1.6;
}

/* The placeholder writes itself out and a hand follows along — it demonstrates the
   gesture rather than describing it. Motion-sensitive users get the static version. */
@media (prefers-reduced-motion: no-preference) {
  .sig-wrap {
    animation: sigreveal 3.8s ease-in-out infinite;
  }
  @keyframes sigreveal {
    0% {
      clip-path: inset(0 100% 0 0);
      opacity: 1;
    }
    58%,
    84% {
      clip-path: inset(0 0 0 0);
      opacity: 1;
    }
    100% {
      clip-path: inset(0 0 0 0);
      opacity: 0;
    }
  }
  .ph-hand {
    animation: handmove 3.8s ease-in-out infinite;
  }
  @keyframes handmove {
    0% {
      left: 8%;
      opacity: 1;
    }
    58%,
    84% {
      left: 88%;
      opacity: 1;
    }
    100% {
      left: 88%;
      opacity: 0;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .ph-hand {
    display: none;
  }
}

.padclear {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--muted-foreground);
  border-radius: 999px;
  padding: 6px 12px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.padclear >>> svg {
  width: 14px;
  height: 14px;
}
</style>
